import React, { memo, useEffect } from 'react';
import { CommonReportDescription } from '@constants/entities/reports';
import useProjectId from '@hooks/useProjectId';
import { getFileData } from '@utils/helpers';
import ExportAsContent from '@views/ReportsModel/components/ExportAsContent/ExportAsContent';
import { ModalWrapper } from '@views/ReportsModel/components/ExportAsContent/ExportAsContent.styled';
import { ModalProps } from '@views/ReportsModel/constants/types';
import useExportNodes from '@views/ReportsModel/hooks/useExportNodes';

export const ExportNodesReportModal = memo((props: ModalProps) => {
  const { open, onClose } = props;
  const projectId = useProjectId(true);

  const {
    handleGenerate,
    isLoading,
    fileContent,
    setFileContent,
    isError,
    setError,
    fileName,
  } = useExportNodes(projectId);

  useEffect(() => {
    if (open) {
      handleGenerate();

      setError(false);
      setFileContent('');
    }
  }, [open]);

  return (
    <ModalWrapper {...props} title="Export as report">
      <ExportAsContent
        files={[
          {
            isGenerating: isLoading,
            generatedFile: getFileData(fileContent, fileName),
            isError,
          },
        ]}
        description={() => CommonReportDescription}
        onClose={onClose}
      />
    </ModalWrapper>
  );
});
